<template>
  <a-modal title="请输入删除密码" :visible="visble" @cancel="cancel" @ok="ok">
    <a-form layout="vertical">
      <ak-type-input v-model="deletePassword" :field="deletePasswordOption" ref="pwd" />
    </a-form>
  </a-modal>
</template>

<script>
import { isNull } from '../../assets/js/validators'
export default {
  props: {
    record: Object, // 当前行的数据
    vm: Object, // 触发这个action的组件对象，通常为modelTable或modelTree
    fields: Array, // 当前model的fields对象
    model: Object, // 当前model对象
    className: String, // 当前model的className
    modelName: String, // 当前model的名称
    category: String // 假如当前model显示为category格式，则会将当前的值传入
  },
  data () {
    return {
      deletePassword: '',
      visble: false,
      del: [],
      deletePasswordOption: {
        name: 'deletePassword',
        note: '密码',
        type: 'String',
        validators: [
          isNull
        ]
      }
    }
  },
  mounted () {
    if (this.vm.selectedRowKeys.length === 0) {
      this.$notification.error({
        message: '数据错误',
        description: '请选择要删除的订单'
      })
    } else {
      this.visble = true
    }
  },
  methods: {
    // 取消
    cancel () {
      this.$emit('complete', 'cancel')
    },
    // 确认
    async ok () {
      this.del = this.vm.selectedRowKeys
      const flag = await this.valatedate()
      if (flag) {
        this.deleteOrder(0, 0, 0)
      } else {
        this.$notification.error({
          message: '数据错误',
          description: '数据错误'
        })
      }
    },
    async deleteOrder (index, gdSuccess, gdError) {
      if (this.deletePassword === this.password) {
        try {
          // 成功回调
          await this.$tkParse.delete(`/classes/Order/${this.del[index]}`)
          this.$emit('complete', 'cancel')
          if (index === this.del.length - 1 && gdError === 0) {
            this.vm.refresh()
            this.$notification.success({
              message: '删除成功',
              description: '数据已删除'
            })
            this.vm.selectedRowKeys = []
          } else if (index === this.del.length - 1 && gdError > 0) {
            this.vm.refresh()
            this.$notification.error({
              message: '网络错误',
              description: '网络错误，成功' + gdSuccess + '条，失败' + gdError + '条'
            })
          } else {
            this.deleteOrder(index + 1, gdSuccess + 1, gdError)
          }
        } catch (e) {
          // 失败回调
          if (index === this.del.length - 1 && gdError === 0) {
            this.vm.refresh()
            this.$notification.success({
              message: '删除成功',
              description: '数据已删除'
            })
            this.vm.selectedRowKeys = []
          } else if (index === this.del.length - 1 && gdError > 0) {
            this.vm.refresh()
            this.$notification.error({
              message: '网络错误',
              description: '网络错误，成功' + gdSuccess + '条，失败' + gdError + '条'
            })
          } else {
            this.deleteOrder(index + 1, gdSuccess, gdError + 1)
          }
        }
      } else {
        this.$notification.error({
          message: '数据错误',
          description: '密码错误'
        })
      }
    },
    async valatedate () {
      const res = await this.$refs.pwd.validate()
      return res === null
    },
    async getDeletePassword () {
      let { data: res } = await this.$tkParse.get('/settings')
      if (res.deleteOrderPassword) {
        this.password = res.deleteOrderPassword
      } else {
        this.password = '123456'
      }
    }
  },
  created () {
    this.getDeletePassword()
  }
}
</script>

<style></style>
